import { Aside } from '@psl/appComponents/Aside';
import {
  adaptiveWrapperOptions,
  ModalWrapper,
} from '@psl/appComponents/ModalWrapper';
import { UserInterfaceIdiomProvider } from '@psl/appComponents/UserInterfaceIdiomContext';
import { useIsMobileLayout } from '@psl/components/styles/responsive';
import type { SellerOnboardingPresentationProps } from '@psl/flows/seller-onboarding/types';
import { screenOptionsForLightMode } from '@psl/functions/navigation/screenOptions';
import { wrapLazyNavigatorScreen } from '@psl/functions/navigation/utils/wrapNavigatorScreen';
import { useResponsiveContext } from '@psl/functions/responsive/ResponsiveContext';
import { lazy } from 'react';
import {
  SafeAreaInsetsContext,
  useSafeAreaInsets,
} from 'react-native-safe-area-context';

const SellerOnboardingFlowContent = lazy(
  () => import('./components/SellerOnboardingFlowContent'),
);

export const SellerOnboardingFlow = wrapLazyNavigatorScreen(
  ({
    nonMobileLayout,
    dismissible,
    ...props
  }: SellerOnboardingPresentationProps & {
    nonMobileLayout?: 'modal' | 'aside';
    dismissible?: boolean;
  }) => {
    const isMobile = useIsMobileLayout();
    const { rpx } = useResponsiveContext();
    const { bottom, top } = useSafeAreaInsets();
    if (isMobile) {
      return (
        <UserInterfaceIdiomProvider
          name="listing-editor"
          userInterfaceStyle="light"
        >
          <SafeAreaInsetsContext.Provider
            value={{
              left: 0,
              right: 0,
              // note(@zhigang1992): fix react navigation bug on presentation: modal style
              top,
              bottom,
            }}
          >
            <SellerOnboardingFlowContent {...props} />
          </SafeAreaInsetsContext.Provider>
        </UserInterfaceIdiomProvider>
      );
    } else {
      if (nonMobileLayout === 'modal') {
        return (
          <UserInterfaceIdiomProvider
            name="settings"
            userInterfaceStyle="light"
          >
            <ModalWrapper
              dismissible={dismissible ?? true}
              width={rpx(400)}
              height={rpx(750)}
            >
              <SellerOnboardingFlowContent {...props} />
            </ModalWrapper>
          </UserInterfaceIdiomProvider>
        );
      } else {
        return (
          <UserInterfaceIdiomProvider
            name="settings"
            userInterfaceStyle="light"
          >
            <Aside dismissible={dismissible ?? true}>
              <SellerOnboardingFlowContent {...props} />
            </Aside>
          </UserInterfaceIdiomProvider>
        );
      }
    }
  },
  adaptiveWrapperOptions(isMobile =>
    isMobile
      ? screenOptionsForLightMode({
          presentation: 'card',
        })
      : screenOptionsForLightMode({
          presentation: 'transparentModal',
          cardOverlayEnabled: true,
          cardStyle: { backgroundColor: 'transparent' },
          animationEnabled: false,
          headerShown: false,
        }),
  ),
);
